import { produce } from 'immer'
import { IRecentView } from './types'

const INITIAL_STATE = {
  recentView: [],
  recentPath: '',
}

export default function user(state: IRecentView = INITIAL_STATE, action): any {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@recentView/CHANGE_RECENT_VIEW': {
        const newRecentView = draft.recentView.filter((f) => f !== action.payload)
        newRecentView.unshift(action.payload)
        if (newRecentView.length > 4) {
          newRecentView.pop()
        }

        draft.recentView = newRecentView
        break
      }

      case '@recentView/CHANGE_RECENT_PATH': {
        draft.recentPath = action.payload
        break
      }

      default:
    }
  })
}
